(* generated by dune *)

(** @canonical Ppx_expect_runtime.Current_file *)
module Current_file = Ppx_expect_runtime__Current_file

(** @canonical Ppx_expect_runtime.Expectation *)
module Expectation = Ppx_expect_runtime__Expectation

(** @canonical Ppx_expect_runtime.Expectation_intf *)
module Expectation_intf = Ppx_expect_runtime__Expectation_intf

(** @canonical Ppx_expect_runtime.Output *)
module Output = Ppx_expect_runtime__Output

(** @canonical Ppx_expect_runtime.Test_block *)
module Test_block = Ppx_expect_runtime__Test_block

(** @canonical Ppx_expect_runtime.Test_node *)
module Test_node = Ppx_expect_runtime__Test_node

(** @canonical Ppx_expect_runtime.Types *)
module Types = Ppx_expect_runtime__Types

(** @canonical Ppx_expect_runtime.Write_corrected_file *)
module Write_corrected_file = Ppx_expect_runtime__Write_corrected_file

module Ppx_expect_runtime__ = struct end
[@@deprecated "this module is shadowed"]
